import React, { RefAttributes } from 'react';
import { ButtonGroup, Dropdown } from 'react-bootstrap';
import { Button } from '../../components/Button';

import { CustomMenu } from './CustomMenu';
import {
  DropdownButtonStylesProps as StylesProps,
  DropdownButton as DropdownButtonStyled,
} from './DropdownButtonStyles';

export type Option = {
  title: string;
  value: string | number;
  divider?: boolean;
  icon?: any;
};

type Props = {
  className?: string;
  variant?: 'primary' | 'secondary' | 'tertiary';
  disabled?: boolean;
  split?: boolean;
  list: Option[];
  drop?: 'left' | 'right' | 'up' | 'down';
  onSelect: (data: Option) => void;
  customIcon?: boolean;
  onClick?: () => void;
} & Partial<StylesProps> &
  RefAttributes<HTMLButtonElement>;

export const DropdownButton: React.FC<Props> = React.forwardRef<
  HTMLButtonElement,
  Props
>(
  (
    {
      className,
      variant = 'primary',
      disabled = false,
      children,
      split,
      list = [],
      drop = 'down',
      onSelect,
      customIcon,
      onClick,
    },
    ref
  ) => {
    return (
      <DropdownButtonStyled
        variant={variant}
        disabled={disabled}
        split={split}
        data-testid='dropdown-container'
      >
        <Dropdown
          as={ButtonGroup}
          ref={ref}
          className={className}
          drop={drop}
          onToggle={() => {
            onClick?.();
          }}
        >
          <Dropdown.Toggle
            data-testid='dropdown-button'
            as={Button}
            variant={variant}
            split={split}
            disabled={disabled}
            className={customIcon ? 'no-arrow' : ''}
          >
            {children}
          </Dropdown.Toggle>
          <Dropdown.Menu as={CustomMenu}>
            {list.map((item: any, i: number) => {
              return (
                <React.Fragment key={i}>
                  {item.divider && <Dropdown.Divider />}
                  <Dropdown.Item
                    key={i}
                    onClick={() => {
                      onSelect(item);
                    }}
                    data-testid='dropdown-options'
                  >
                    {item.icon}
                    {item.title}
                  </Dropdown.Item>
                </React.Fragment>
              );
            })}
          </Dropdown.Menu>
        </Dropdown>
      </DropdownButtonStyled>
    );
  }
);
